import React, { Component, Fragment } from 'react'
import { message } from 'antd'
import ReceiptsApi from '../../../../api/Sales/Receipts'
import { get, pick, set, sumBy } from 'lodash'
import { numVal } from '../../../../modules/Utils'
import Receipts from './Receipts'
import { dateFormat, dateVal, moneyInline, strVal } from '../../../../modules/Utils'
import Email from '../../../../api/Email'

class ReceiptsCont extends Component {
  api = new ReceiptsApi()
  emailApi = new Email()

  state = {
    receipt: {},
    calculation: {},
    emailKey: '1',
    selection: [],
    list: [],
    show: { companyFilter: true },
  }
  formRef = React.createRef()
  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const list = await this.api.list(
        get(this.props, 'contract._id'),
        get(this.props, 'invoice._id'),
      )
      this.setState({
        fetching: false,
        list,
        cached: list,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  fetchLines = async () => {
    try {
      this.setState({
        fetchingLines: true,
      })
      const lines = await this.api.lines.list(this.state.receipt._key)
      const { receipt } = this.state
      const total = sumBy(lines, i => numVal(i, 'amount'))

      lines.forEach(i => {
        i.newBalance =
          numVal(i, 'invoice.subTotal.gross') -
          (numVal(i, 'amount') +
            numVal(i, 'invoice.paid') +
            numVal(i, 'discount') +
            numVal(i, 'invoice.wtax.tax'))
      })
      let calculation = { contract: numVal(receipt, 'contract.amount') }

      calculation.remaining = numVal(receipt, 'transaction.amount') - calculation.contract - total
      calculation.total = sumBy(lines, i => numVal(i, 'invoice.subtotal.gross'))
      calculation.allocated = total

      this.setState({
        fetchingLines: false,
        lines,
        calculation,
        cachedLines: lines,
      })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ fetchingLines: false })
    }
  }
  fetchReceipt = async key => {
    try {
      this.setState({
        visible: true,
        type: 'edit',
        fetchingReceipt: true,
      })
      const receipt = await this.api.read(key)
      let lines = await this.api.lines.list(key)
      const total = sumBy(lines, i => numVal(i, 'amount'))
      lines.forEach(i => {
        i.newBalance =
          numVal(i, 'invoice.subTotal.gross') -
          (numVal(i, 'amount') +
            numVal(i, 'invoice.paid') +
            numVal(i, 'discount') +
            numVal(i, 'invoice.wtax.tax'))
      })
      let calculation = { contract: numVal(receipt, 'contract.amount') }
      calculation.remaining = numVal(receipt, 'transaction.amount') - calculation.contract - total
      calculation.total = sumBy(lines, i => numVal(i, 'invoice.subtotal.gross'))
      calculation.allocated = total
      this.setState({
        fetchingReceipt: false,
        lines,
        cachedLines: lines,
        calculation,
        transaction: receipt.transaction,
        receipt,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ fetchingReceipt: false, visible: false })
    }
  }
  onEdit = async (e, receipt) => {
    await this.fetchReceipt(receipt._key)
    this.setState({
      visible: true,
      type: 'edit',
    })
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFields((err, values) => {
        if (!err) {
          this.setState({
            receipt: Object.assign({}, this.state.receipt, values),
          })
          res(true)
        }
      })
    })
  }
  update = async () => {
    await this.checkForm()
    try {
      let { receipt } = this.state
      receipt.transaction = pick(this.state.transaction, ['_id'])
      receipt.invoices = this.state.invoices
        .filter(
          i => numVal(i, 'amount') > 0 || numVal(i, 'discount') > 0 || numVal(i, 'wtax.tax') > 0,
        )
        .map(i => pick(i, ['_id', 'amount', 'discount', 'wtax.tax']))
      if (this.state.calculation.remaining !== 0) {
        message.error('Make sure that remaining is equal to zero 0 .')
        return
      }
      this.setState({
        submitting: true,
      })
      await this.api.update(
        pick(receipt, [
          'transaction',
          'code',
          'status',
          '_history',
          'company',
          'revision',
          'amount',
        ]),
      )
      this.setState({
        submitting: false,
      })
      this.onCancel()
      await this.fetch()
      await this.fetchReceipts()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  onChangeCompany = _id => {
    this.setState(prevState => ({
      list: _id ? prevState.cached.filter(i => i.company._id === _id) : prevState.cached,
      company: _id,
    }))
  }
  onChangeContractAllocated = value => {
    this.setState((prevState, props) => {
      let calculation = prevState.calculation
      calculation.contract = numVal({ value }, 'value')
      calculation.remaining =
        numVal(prevState, 'transaction.amount') -
        (calculation.allocated + numVal({ value }, 'value'))
      return { calculation }
    })
  }
  onCancel = () => {
    this.setState({
      visible: false,
      lines: [],
    })
  }
  linesOps = {
    cancel: _key => {
      let lines = [...this.state.lines]
      let target = lines.find(item => _key === item._key)
      if (target) {
        target = { ...this.state.cachedLines.find(item => _key === item._key) }
        delete target.editable
        if (Object.keys(target).length === 1 && Object.keys(target)[0] === '_key')
          this.remove(target._key)
        else this.setState({ lines: lines })
      }
    },
    remove: async _key => {
      const newData = [...this.state.lines]
      const target = newData.find(item => _key === item._key)
      if (target) {
        this.setState({
          fetchingLines: true,
        })
        await this.api.lines.remove(pick(target, ['_id', '_rev', '_key']))
        await this.fetchLines()
      }
    },
    edit: _key => {
      const newData = [...this.state.lines]
      const target = newData.filter(item => _key === item._key)[0]
      if (target) {
        target.editable = true
        this.setState({ lines: newData })
      }
    },
    save: async _key => {
      const newData = [...this.state.lines]
      const target = newData.find(item => _key === item._key)
      if (target) {
        this.setState({
          fetchingLines: true,
        })
        await this.api.lines.update(pick(target, ['_id', '_rev', '_key', 'amount', 'discount']))
        await this.fetchLines()
      }
    },
  }
  handleChange = (value, _key, column) => {
    const newData = [...this.state.lines]
    const target = newData.find(item => _key === item._key)
    if (target) {
      set(target, column, value)
      this.setState({ lines: newData })
    }
  }
  remove = async () => {
    const { receipt } = this.state
    try {
      this.setState({
        removing: true,
      })
      await this.api.remove(pick(receipt, ['_id', '_key', '_rev']))
      this.setState({
        removing: false,
      })
      this.onCancel()
      await this.fetch()
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ removing: false })
    }
  }
  receiptsOps = {
    reject: async receipt => {
      try {
        this.setState({
          fetching: true,
        })
        await this.api.operation('reject', pick(receipt, ['_id', '_key', '_rev']))
        this.setState({
          fetching: false,
        })
        await this.fetchReceipts()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({ fetching: false })
      }
    },
    approve: async receipt => {
      try {
        this.setState({
          fetching: true,
        })
        await this.api.operation('approve', pick(receipt, ['_id', '_key', '_rev']))
        this.setState({
          fetching: false,
        })
        await this.fetchReceipts()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({ fetching: false })
      }
    },
    submit: async receipt => {
      try {
        this.setState({
          fetching: true,
        })
        await this.api.operation('submit', pick(receipt, ['_id', '_key', '_rev']))
        this.setState({
          fetching: false,
        })
        await this.fetchReceipts()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({ fetching: false })
      }
    },
  }
  toggleSelection = key => {
    let selection = [...this.state.selection]
    const keyIndex = selection.indexOf(key)
    if (keyIndex >= 0) {
      selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)]
    } else {
      selection.push(key)
    }
    this.setState({ selection })
  }
  toggleAll = () => {
    const selectAll = !this.state.selectAll
    const selection = []
    if (selectAll) {
      const wrappedInstance = this.formRef.current.getWrappedInstance()
      const currentRecords = wrappedInstance.getResolvedState().sortedData
      currentRecords.forEach(item => {
        selection.push(item._original._id)
      })
    }
    this.setState({ selectAll, selection })
  }
  isSelected = key => {
    return this.state.selection.includes(key)
  }
  showEmail = async () => {
    const selection = this.state.selection.map(t => this.state.list.find(i => i._id === t))
    if (
      !selection.reduce((prv, current) =>
        get(prv, 'client._id') === get(current, 'client._id') ? prv : NaN,
      )
    ) {
      message.error('Not the same Client')
      return
    }
    if (
      !selection.reduce((prv, current) =>
        get(prv, 'company._id') === get(current, 'company._id') ? prv : NaN,
      )
    ) {
      message.error('Not the same company')
      return
    }
    try {
      this.setState({
        fetchingEmailTemplate: true,
      })
      const lines = selection.map(i => ({
        ref: strVal(i, 'transaction.notes'),
        date: dateFormat(dateVal(i, 'date')),
        no: i.revision ? strVal(i, 'code') + '.0' + strVal(i, 'revision') : strVal(i, 'code'),
        invoice: get(i, 'invoice.code') ? strVal(i, 'invoice.code') : '',
        amount: moneyInline(numVal(i, 'allocated'), strVal(i, 'currency')),
      }))
      const receiptTemplate = await this.templateApi.read(
        strVal(selection, '0.company._id').replace('members/', ''),
        'receipt',
      )
      const emailDetails = get(receiptTemplate, 'email') || {}
      const data = await this.emailApi.receiptTemplate({
        receiver: get(selection, '0.payableRep.fn'),
        company: get(selection, '0.company'),
        companyRep: get(selection, '0.contract.companyRep.fn'),
        lines: lines,
        ...emailDetails,
      })
      const filesList = await this.api.files(selection.map(s => s._id))
      const filesMapped = filesList.map(f => f._key)
      this.setState({
        visibleEmail: true,
        emailTemplate: data.html,
        fetchingEmailTemplate: false,
        emailFiles: filesList,
        emailLines: selection,
        emailDetails: {
          to: get(selection, '0.payableRep.email.label'),
          cc: get(selection, '0.contract.companyRep.email.label'),
          bcc: get(emailDetails, 'bcc'),
          from: get(emailDetails, 'from'),
          subject: get(emailDetails, 'subject'),
          attachments: filesMapped,
        },
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({
        fetchingEmailTemplate: false,
      })
    }
  }
  onCancelEmail = () => {
    this.setState({
      visibleEmail: false,
      emailDetails: {},
      selection: [],
    })
  }

  render() {
    return (
      <Fragment>
        <Receipts
          {...this.state}
          {...pick(this, [
            'fetch',
            'remove',
            'fetchLines',
            'linesOps',
            'handleChange',
            'receiptsOps',
            'onChangeCompany',
            'onChangeContractAllocated',
            'onEdit',
            'showEmail',
            'onCancelEmail',
            'onCancel',
            'formRef',
            'toggleSelection',
            'toggleAll',
            'isSelected',
            'showEmail',
            'onCancelEmail',
            'fetchingEmailTemplate',
          ])}
        />
      </Fragment>
    )
  }
}

ReceiptsCont.propTypes = {}
ReceiptsCont.defaultProps = {}

export default ReceiptsCont
